import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useAuth } from '../context/AuthContext';
import useCollection from './useCollection';
import { FaTrashAlt } from 'react-icons/fa';

const Discussion = () => {
  const { profile } = useAuth();
  const { items: messages, loading } = useCollection('messages', 'created_at', true);
  const [text, setText] = useState('');
  const [error, setError] = useState('');

  const isDirectorOrAdmin = profile?.is_admin || profile?.role === 'director';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!text.trim()) return;
    const { error: insertError } = await supabase.from('messages').insert({
      text: text.trim(),
      author: profile?.name || 'Membre',
    });
    if (insertError) {
      setError("Impossible d'envoyer le message : " + insertError.message);
      return;
    }
    setText('');
  };

  const handleDelete = async (id) => {
    if (window.confirm("Voulez-vous supprimer ce message ?")) {
      const { error: deleteError } = await supabase.from('messages').delete().eq('id', id);
      if (deleteError) {
        setError("Impossible de supprimer le message : " + deleteError.message);
      }
    }
  };

  return (
    <div className="membres-section">
      <h3>Fil de discussion</h3>
      {loading ? (
        <p>Chargement...</p>
      ) : (
        <ul className="membres-feed">
          {messages.map((m) => {
            // Suppression autorisée si Admin, Metteuse en scène, ou Auteur du message
            const canDelete = isDirectorOrAdmin || m.author === profile?.name;

            return (
              <li key={m.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <strong>{m.author} :</strong> {m.text}
                </div>
                {canDelete && (
                  <button
                    type="button"
                    onClick={() => handleDelete(m.id)}
                    style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer', padding: '4px' }}
                    title="Supprimer le message"
                  >
                    <FaTrashAlt />
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      )}
      {error && <p className="membres-error">{error}</p>}
      <form onSubmit={handleSubmit} className="membres-inline-form">
        <input
          type="text"
          placeholder="Écrire un message..."
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <button type="submit" className="membres-btn">Envoyer</button>
      </form>
    </div>
  );
};

export default Discussion;